// extracted by mini-css-extract-plugin
module.exports = {"caption":"NFTMoreSection_caption__PNISu","seeMore":"NFTMoreSection_seeMore__ctd1a"};